import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { EMPTY, fromEvent, map, merge, tap } from 'rxjs'

export const SUPPORT_MODAL_HASH = '#ticket-form'

/**
 * Single source for the support-modal URL so the history entry written here and
 * the login `returnTo` built in `TicketForm` cannot drift apart. Keeping the
 * query is what carries UTM params through the modal.
 */
export const supportModalUrl = (pathname: string, search: string): string =>
  `${pathname}${search}${SUPPORT_MODAL_HASH}`

const [supportModalOpenChange$, setSupportModalOpen] = createSignal<boolean>()

export { setSupportModalOpen }

const modalStateFromPopStateEvent$ =
  typeof window === 'undefined'
    ? EMPTY
    : fromEvent(window, 'popstate').pipe(map(() => window.location.hash === SUPPORT_MODAL_HASH))

const modalStateFromSignal$ =
  typeof window === 'undefined'
    ? EMPTY
    : supportModalOpenChange$.pipe(
        tap((state) => {
          if (state) {
            window.history.pushState(
              { _tag: 'TicketForm' },
              'Ticket',
              supportModalUrl(window.location.pathname, window.location.search),
            )
          } else {
            window.history.replaceState(
              {},
              '',
              `${window.location.pathname}${window.location.search}`,
            )
          }
        }),
      )

export const [useSupportModalState, supportModalState$] = bind(
  merge(modalStateFromSignal$, modalStateFromPopStateEvent$),
  false,
)
